import api from "../lib/api";
import { ClassRankingEntry, FitsStore } from "../types";

// Api.ts 를 다시 생성하기 전까지는 생성된 메서드가 없어 request 로 직접 부른다.
export const getFitsStore = async (username: string) => {
  const { data } = await api.request<FitsStore>({
    path: `/fits/store/${username}`,
    method: "GET",
    format: "json",
  });
  return data;
};

export const classHeartRateUrl = (classId: number, username: string) =>
  `${process.env.REACT_APP_NEW_API_URL}/fits-realtime/classes/${classId}/heart-rate?username=${encodeURIComponent(username)}`;

/** 그 수업을 지금 확정하고 TOP 5 를 받는다. 이미 확정됐으면 순위만 준다(여러 화면이 불러도 한 번만 지급). */
export const postClassRanking = async (classId: number, username: string) => {
  const { data } = await api.request<{ ranking: ClassRankingEntry[] }>({
    path: `/fits/classes/${classId}/ranking`,
    method: "POST",
    query: { username },
    format: "json",
  });
  return data.ranking;
};
